// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n/*.crop {*/\r\n/*  width: 600px;*/\r\n/*  height: 200px;*/\r\n/*  overflow: hidden;*/\r\n/*  !*     margin: 10px; *!*/\r\n/*  position: relative;*/\r\n/*}*/\r\n/*.crop img {*/\r\n/*  position: absolute;*/\r\n/*  left: -1000%;*/\r\n/*  right: -1000%;*/\r\n/*  top: -1000%;*/\r\n/*  bottom: -1000%;*/\r\n/*  margin: auto;*/\r\n/*  min-height: 100%;*/\r\n/*  min-width: 100%;*/\r\n/*}*/\r\n", ""]);
// Exports
module.exports = exports;
